import React from 'react';
import { useTranslation } from '../utils/languageUtils';

const SidebarItem = ({ item, isActive, onClick }) => {
  const { t } = useTranslation();
  const translatedLabel = t(item.label, item.label);
  
  // Handle both React component icons and string icons
  const renderIcon = () => {
    if (typeof item.icon === 'function') {
      // React component icon
      const IconComponent = item.icon;
      return <IconComponent size={20} />;
    } else {
      // String icon (emoji or text)
      return item.icon;
    }
  };
  
  // Handle touch events to prevent iOS dragging issues
  const handleTouchStart = (e) => {
    // Prevent default touch behavior on iOS
    e.preventDefault();
  };
  
  const handleClick = (e) => {
    // For iOS, prevent any potential dragging behavior
    e.preventDefault();
    onClick();
  };
  
  return (
    <button 
      className={`sidebar-item ${isActive ? 'active' : ''}`}
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      title={translatedLabel}
      // Add additional attributes to prevent iOS dragging
      draggable="false"
    >
      <span className="sidebar-icon">{renderIcon()}</span>
      <span className="sidebar-label">{translatedLabel}</span>
    </button>
  );
};

export default SidebarItem;
